import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { SEARCH } from 'constants/filter-sets';

import { filterSetFilters } from 'redux/saga/selectors';
import { deepExtract } from 'helpers/deep';
import { searchFilterActions } from './filters.helpers';
import { TIME_DEFAULT, filterChanged } from './filters.saga';

import { TimeFilter } from '../components/filters/TimeFilter';
import { FILTER_NAMES } from '../Search.constants';

const { setFilterValue, setFilterEditing } = searchFilterActions;

const { TIME } = FILTER_NAMES;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const presets = deepExtract(`${TIME}.itemsById`, filters, {});
  const selectedTimeRange = deepExtract(`${TIME}.value`, filters) || TIME_DEFAULT;
  const isOutOfSync = deepExtract(`${TIME}.needsUpdate`, filters, true);
  const isEditing = deepExtract(`${TIME}.isEditing`, filters, false);
  const isDefault = selectedTimeRange === TIME_DEFAULT;
  const presetValue = presets[selectedTimeRange];
  const presetName = presetValue && presetValue.name;

  return {
    isMobile: selectIsMobile(state),
    isSelected: !isDefault,
    isSlider: !presetValue && !isDefault,
    defaultValue: TIME_DEFAULT,
    presets,
    presetName,
    selectedTimeRange,
    isOutOfSync,
    isEditing,
  };
};

export const mapDispatchToProps = {
  onTimeRangeSelected: (id, options) => setFilterValue(TIME, id, options),
  onSyncTimeFilter: () => filterChanged(TIME),
  onClear: () => setFilterValue(TIME, TIME_DEFAULT),
  onSetIsEditing: isEditing => setFilterEditing(TIME, isEditing),
};

const TimeFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeFilter);

export { TimeFilterContainer };
